import PropsTypes from "prop-types";

const providerExportOrderProps = {
  type: {
    isOpenModal: PropsTypes.bool.isRequired,
    setIsOpenModal: PropsTypes.func.isRequired,
  },
};

export default providerExportOrderProps;
